import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { getIcon } from '@framework/workbench/ui/insert/insert-addon/config';
import { TOOLBAR_LATEX } from '@editor/src/img/pageIndex';
import { wrapIdForBig } from '@src/framework/workbench/util/wrap-id-util';

export const config = {
    id: ActionType.INSERT_WITH_LATEX,
    content: i18n.t('LaTeX公式'),
    icon: TOOLBAR_LATEX,
    tipMsg: i18n.t('插入LaTeX公式'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: getIcon(config.icon),
        text: config.content,
        tooltip: config.tipMsg,
        style: {
            width: 'auto',
        },
        respectOffline: true,
    },
    {
        name: wrapIdForBig(config.id),
        icon: getIcon(config.icon),
        text: config.content,
        tooltip: config.tipMsg,
    },
];

export const MENU_ITESMS: MenuConfig[] = [{
    name: config.id,
    icon: getIcon(TOOLBAR_LATEX),
    content: config.content,
    tooltip: config.tipMsg,
    respectOffline: true,
}];
